import { render, staticRenderFns } from "./credibility_points.vue?vue&type=template&id=580cc3e3&scoped=true"
import script from "./credibility_points.vue?vue&type=script&lang=ts"
export * from "./credibility_points.vue?vue&type=script&lang=ts"
import style0 from "./credibility_points.vue?vue&type=style&index=0&id=580cc3e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580cc3e3",
  null
  
)

export default component.exports